<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-22 11:49:02
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-09-10 15:45:13
 * @name: 支付确认
 * @Description: 支付确认
 * @FilePath: \preSaleNafterSaleBackstage\src\views\approvalManage\payConfirmManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <flow-panel ref="flowPanel" class="flowPanel" :flow="flow"></flow-panel>
</template>
<script>
import FlowPanel from "@/components/ef/panel.vue";
import flow from "@/object/flow/flow.class.js";

export default {
  name: "payConfirmManage",
  components: {
    FlowPanel,
  },
  data() {
    return {
      flow: new flow(),
    };
  },
  activated() {
    this.$nextTick(() => {
      this.$refs.flowPanel.start(1);
    });
  },
};
</script>
<style lang="scss" scoped>
.flowPanel {
  background: white;
}
</style>